import {
  BarChart07Icon,
  ClockIcon,
  CurrencyDollarIcon,
  Lightning01Icon,
  Mail01Icon,
  Settings04Icon,
  SwitchHorizontal02Icon,
  Users01Icon,
} from '@systemeio/icons'
import { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum'
import type { JSX } from 'react'

export interface SettingsTabInterface {
  type: FunnelStepSettingTabsEnum
  caption: string
  iconRenderer: () => JSX.Element
}

export const funnelSettingTabsList: SettingsTabInterface[] = [
  {
    type: FunnelStepSettingTabsEnum.stepConfiguration,
    caption: 'dashboard.funnel.step_configuration',
    iconRenderer: () => <Settings04Icon />,
  },
  {
    type: FunnelStepSettingTabsEnum.automationRules,
    caption: 'dashboard.funnel.automation_rules.title',
    iconRenderer: () => <Lightning01Icon />,
  },
  {
    type: FunnelStepSettingTabsEnum.tests,
    caption: 'dashboard.funnel.split_tests_title',
    iconRenderer: () => <SwitchHorizontal02Icon />,
  },
  {
    type: FunnelStepSettingTabsEnum.stats,
    caption: 'dashboard.funnel.stats',
    iconRenderer: () => <BarChart07Icon />,
  },
  {
    type: FunnelStepSettingTabsEnum.leads,
    caption: 'dashboard.funnel.leads',
    iconRenderer: () => <Users01Icon />,
  },
  {
    type: FunnelStepSettingTabsEnum.sales,
    caption: 'dashboard.funnel.statistics.sales',
    iconRenderer: () => <CurrencyDollarIcon />,
  },
  {
    type: FunnelStepSettingTabsEnum.deadlineSettings,
    caption: 'dashboard.funnel.deadline_settings',
    iconRenderer: () => <ClockIcon />,
  },
]

export const funnelStepSettingsEmailsTab = {
  type: FunnelStepSettingTabsEnum.emails,
  caption: 'dashboard.funnel.emails',
  iconRenderer: () => <Mail01Icon />,
}

export const funnelSettingTabsListWithEmails = [
  ...funnelSettingTabsList,
  funnelStepSettingsEmailsTab,
]
